import { useContext } from 'react';

import { AuthContext } from './AuthContext';
import type { AuthState } from './AuthContext';

/**
 * Lấy trạng thái xác thực.
 *
 * Ném lỗi khi được gọi ngoài phạm vi cung cấp trạng thái. Đó là lỗi lập trình, và ném ngay
 * cho ra thông báo rõ ràng hơn nhiều so với việc trả về giá trị rỗng rồi để lỗi phát ra ở
 * một chỗ khác không liên quan.
 */
export function useAuth(): AuthState {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error(
      'useAuth phải được gọi bên trong AuthProvider. '
      + 'Kiểm tra lại cây thành phần ở main.tsx.',
    );
  }

  return context;
}
